import { useEffect, useState } from "react";
import { Props } from "./useGetCheckoutPage.model";
import { SubscribeToCheckoutPage } from "../../../apis/Admin/Checkout";

const useGetCheckoutPage = (props: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const [checkoutPage, setCheckoutPage] = useState<
    ICheckoutPage | null | undefined
  >(undefined);

  useEffect(() => {
    if (typeof props.pageId === "string" && props.pageId.length > 0) {
      const unsubscribe = SubscribeToCheckoutPage(
        props.pageId,
        (checkoutPage) => {
          if (checkoutPage === "NO_EXIST") {
            setIsSuccess(true);
            setCheckoutPage(null);
          } else {
            setIsSuccess(true);
            setCheckoutPage(checkoutPage);
          }
          setIsLoading(false);
        },
        () => {
          setCheckoutPage(null);
          setIsLoading(false);
        }
      );

      return () => unsubscribe();
    }
  }, [props.pageId]);

  return {
    isLoading,
    isSuccess,
    checkoutPage,
  };
};

export { useGetCheckoutPage };
